var map = {
	"./HotspotChoice.png": "4365",
	"./HotspotInfo.png": "7b9b",
	"./HotspotTeleport.png": "dc15",
	"./HotspotTriage.png": "099b",
	"./body.png": "fb5b",
	"./body1.png": "daf7",
	"./body_red.png": "16d4",
	"./body_red_green.png": "9604"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b917";